// extracted by mini-css-extract-plugin
module.exports = {"container":"l_QwMtXKsukCbNZ8Y5Nux","item":"pcSJhgA62OJDhSEmkQyu3","icon":"_2VZBhqN78EHdBWyIa3Wq7L","dot":"KtgVuuw85D8Ov4shCdr_6"};